import {useDebugValue} from 'react';

import {useTranslations} from './useTranslations';

const defaultDestinationTranslations = {
    clearSearchLabel: 'Clear Search',
    errorMessageText: 'Tell us where you\'re traveling',
    noResultsFoundMessage: 'No results found',
    placeholderMessage: 'Where to?',
    premiseLabel: 'Premise',
    premisesLabel: 'Premises',
    recentSearchesMessage: 'Your recent searches',
    recentlyViewedLabel: 'Recently Viewed',
    resultsFoundMessage: '{NUM_RESULTS} results. Use the up and down keys to navigate.',
    selectedMessage: 'Destination selected: {DESTINATION}',
    trendingDestinationsMessage: 'Trending destinations today',
    typeAirportLabel: 'Airport',
    typeCityLabel: 'City',
    typeLandmarkLabel: 'Landmark',
    typeMetroStationLabel: 'Metro Station',
    typeNeighborhoodLabel: 'Neighborhood',
    typePropertyLabel: 'Property',
    typeRegionLabel: 'Region',
    typeTrainStationLabel: 'Train Station',
    whereLabel: 'Where'
};

function useDestinationTranslations(props) {
    const {
        destinationTranslations: propsDestinationTranslations
    } = props;

    const {
        translations: destinationTranslations
    } = useTranslations(defaultDestinationTranslations, propsDestinationTranslations);

    const result = {
        destinationTranslations
    };

    useDebugValue(result);

    return result;
}

export {useDestinationTranslations};
